import { useEffect, useState } from "react";

const ServiceSlider = () => {
  const services = [
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M2 5a2 2 0 012-2h12a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm3.293 1.293a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 01-1.414-1.414L7.586 10 5.293 7.707a1 1 0 010-1.414zM11 12a1 1 0 100 2h3a1 1 0 100-2h-3z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: "Custom Software Development",
      description:
        "We offer full IT services like Cryptocurrency App Development, IoT App Development, Software Development, Mobile Application Development, Web Development, Application Integrations and also work on many more new technologies to deliver the best for all businesses.",
      link: "/services/custom-software-development",
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
          <path d="M7 3a1 1 0 000 2h6a1 1 0 100-2H7zM4 7a1 1 0 011-1h10a1 1 0 110 2H5a1 1 0 01-1-1zM2 11a2 2 0 012-2h12a2 2 0 012 2v4a2 2 0 01-2 2H4a2 2 0 01-2-2v-4z" />
        </svg>
      ),
      title: "Mobile Application Development",
      description:
        "We are the top Mobile App Development Company, known for its excellent quality. Also, we are one of the Fastest Growing Mobile App (Android / IOS) Development Companies in India.",
      link: "/services/mobile-app-development",
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M4 4h16v2H4V4zm2 4h12v2H6V8zm-2 4h16v2H4v-2zm2 4h12v2H6v-2zm-2 4h16v2H4v-2z" />
        </svg>
      ),
      title: "API Development",
      description:
        "We specialize in building secure, scalable, and high-performing APIs that enable smooth integration between applications, services, and platforms—empowering businesses with flexible and future-ready solutions.",
      link: "/services/api-development",
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M12.316 3.051a1 1 0 01.633 1.265l-4 12a1 1 0 11-1.898-.632l4-12a1 1 0 011.265-.633zM5.707 6.293a1 1 0 010 1.414L3.414 10l2.293 2.293a1 1 0 11-1.414 1.414l-3-3a1 1 0 010-1.414l3-3a1 1 0 011.414 0zm8.586 0a1 1 0 011.414 0l3 3a1 1 0 010 1.414l-3 3a1 1 0 11-1.414-1.414L16.586 10l-2.293-2.293a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: "Integrations",
      description:
        "Data integration involves a combination of data that is accumulated to a centralized system from several sources. The stored data in different sources are obtained using different technologies to show it in a unified view.",
      link: "/services/integration",
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M4 3h2v18H4V3zm4 6h2v12H8V9zm4-4h2v16h-2V5zm4 6h2v10h-2V11zm4-6h2v16h-2V5z" />
        </svg>
      ),
      title: "Data Analytics",
      description:
        "Unlock insights and drive informed decisions with our data analytics services using industry-leading tools like Power BI and Tableau.",
      link: "/services/data-analytics",
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
          <path d="M3 12v3c0 1.657 3.134 3 7 3s7-1.343 7-3v-3c0 1.657-3.134 3-7 3s-7-1.343-7-3z" />
          <path d="M3 7v3c0 1.657 3.134 3 7 3s7-1.343 7-3V7c0 1.657-3.134 3-7 3S3 8.657 3 7z" />
          <path d="M17 5c0 1.657-3.134 3-7 3S3 6.657 3 5s3.134-3 7-3 7 1.343 7 3z" />
        </svg>
      ),
      title: "Big Data Development",
      description:
        "Big Data relates to the large quantities of data which flow in from multiple data sources and have various formats. It is much more than a group of datasets with different formats, it is an important resource which can be used to get innumerable benefits.",
      link: "/services/big-data",
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2a10 10 0 00-3.516 19.367c.555.102.757-.241.757-.537v-1.933c-3.088.672-3.737-1.29-3.737-1.29-.505-1.287-1.234-1.63-1.234-1.63-1.01-.691.077-.676.077-.676 1.117.078 1.704 1.148 1.704 1.148.993 1.702 2.606 1.21 3.243.925.101-.719.389-1.21.708-1.488-2.465-.28-5.055-1.232-5.055-5.482 0-1.211.434-2.2 1.145-2.975-.115-.282-.497-1.417.108-2.957 0 0 .933-.298 3.06 1.136a10.557 10.557 0 015.57 0c2.126-1.434 3.058-1.136 3.058-1.136.607 1.54.224 2.675.11 2.957.713.774 1.144 1.763 1.144 2.975 0 4.262-2.594 5.2-5.067 5.474.401.346.76 1.029.76 2.074v3.073c0 .299.199.644.766.534A10.004 10.004 0 0012 2z" />
        </svg>
      ),
      title: "AI, ML & Generative AI",
      description:
        "Empowering innovation with cutting-edge AI, Machine Learning, and Generative AI solutions that automate processes, enhance decision-making, and unlock new digital experiences.",
      link: "/services/ai-ml-genai",
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
          <path d="M4 3a1 1 0 00-1 1v12a1 1 0 001 1h6v-2H5V5h10v4h2V4a1 1 0 00-1-1H4zm11 10h-3v3h-2v-3H7l4-4 4 4z" />
        </svg>
      ),
      title: "SAP Services",
      description:
        "We offer end-to-end SAP services designed to help organizations streamline their processes, improve efficiency, and gain real-time insights.",
      link: "/services/sap-services",
    },
    {
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M2 5a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2V5zm14 1a1 1 0 11-2 0 1 1 0 012 0zM2 13a2 2 0 012-2h12a2 2 0 012 2v2a2 2 0 01-2 2H4a2 2 0 01-2-2v-2zm14 1a1 1 0 11-2 0 1 1 0 012 0z"
            clipRule="evenodd"
          />
        </svg>
      ),
      title: "Odoo Services",
      description:
        "We help businesses turn raw data into meaningful insights using industry-leading tools like Power BI and Tableau, enabling better decision-making and performance tracking through powerful visual dashboards.",
      link: "/services/odoo-services",
    },
  ];

  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % services.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [services.length]);

  const handleNext = () =>
    setCurrentSlide((prev) => (prev + 1) % services.length);
  const handlePrevious = () =>
    setCurrentSlide((prev) => (prev - 1 + services.length) % services.length);

  return (
    <section
      className="py-20 relative overflow-hidden bg-cover bg-center"
      style={{
        // backgroundImage: "url('/assets/images/about/bg.png')",
        backgroundAttachment: "fixed",
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/20"></div>

      <div className="relative container mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl mb-4 font-extrabold text-black">
            Our IT Solutions & Services
          </h2>
          <div class="w-20 h-1 bg-black mx-auto mb-6"></div>
        </div>

        {/* Slider */}
        <div className="relative flex items-center">
          {/* Left */}
          <button
            onClick={handlePrevious}
            className="absolute -left-6 z-20 bg-white shadow-md w-10 h-10 rounded-full flex items-center justify-center text-indigo-600 hover:bg-indigo-600 hover:text-white transition"
          >
            ‹
          </button>

          {/* Cards */}
          <div className="flex gap-6 overflow-hidden w-full">
            <div
              className="flex gap-6 transition-transform duration-700 ease-in-out"
              style={{
                transform: `translateX(-${currentSlide * (100 / 3)}%)`,
                width: `${services.length * (100 / 3)}%`,
              }}
            >
              {services.map((service, index) => (
                <div
                  key={index}
                  className="w-1/3 bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition flex-shrink-0 flex flex-col"
                >
                  <div className="w-14 h-14 mb-4 flex items-center justify-center rounded-full bg-gradient-to-r from-indigo-500 to-purple-600 text-white">
                    {service.icon}
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 mb-2">
                    {service.title}
                  </h3>

                  <p className="text-gray-600 text-sm leading-relaxed mb-4">
                    {service.description}
                  </p>

                  {/* Button pushed to bottom */}
                  <div className="mt-auto">
                    <a
                      href={service.link}
                      className="inline-block px-4 py-2 text-sm font-medium text-indigo-600 border border-indigo-600 rounded-full hover:bg-indigo-600 hover:text-white transition"
                    >
                      Learn More →
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right */}
          <button
            onClick={handleNext}
            className="absolute -right-6 z-20 bg-white shadow-md w-10 h-10 rounded-full flex items-center justify-center text-indigo-600 hover:bg-indigo-600 hover:text-white transition"
          >
            ›
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServiceSlider;
